<template>
  <div>
    auto fill
  </div>
</template>

<script>
export default {
  name: 'component_auto_fill_keywords'
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/component/component_auto_fill_keywords.vue